import React, { useEffect } from 'react'
import useReactRouter from 'use-react-router'
import { Table, Popconfirm, Layout, PageHeader } from 'antd'
import notification from 'mrx-notification'
import { ColumnsType } from 'antd/lib/table'
import { Breadcrumbs } from 'components'
import * as rootStyles from 'assets/layoutStyle'
import styles from './PostmarkSettingsList.module.scss'
import { connector, PropsFromRedux } from './container'
import { PostmarkSetting } from '../../types'
import CreatePostmarkSetting from '../CreatePostmarkSetting'

const PostmarkSettingsList = (props: PropsFromRedux) => {
  const {
    postmarkSettingsList,
    isLoading,
    error,
    isNeedToFetchList,
    total,
    currentPage,

    removePostmarkSetting,
    fetchPostmarkSettingsList,
    changeCurrentPage
  } = props

  const { history } = useReactRouter()

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'Postmark settings list page error!',
        description: error
      })
    }
  }, [error])

  useEffect(() => {
    isNeedToFetchList && fetchPostmarkSettingsList()
  }, [fetchPostmarkSettingsList, isNeedToFetchList])

  const doConfirm = async (postmarkSettingId: number, e?: React.MouseEvent<HTMLElement>) => {
    e && e.stopPropagation()
    const isRemoved = await removePostmarkSetting(postmarkSettingId)
    if (isRemoved) {
      notification.success({
        message: 'Successfully',
        description: 'Postmark setting was deleted successfully!'
      })
    }
  }

  const columns: ColumnsType<PostmarkSetting> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'API Key',
      dataIndex: 'apiKey',
      key: 'apiKey'
    },
    {
      title: 'From email',
      dataIndex: 'from',
      key: 'from'
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'x',
      render: (record: PostmarkSetting) => (
        <span>
          <Popconfirm
            title='Are you sure delete this setting?'
            onConfirm={(e) => doConfirm(record.id, e)}
            onCancel={(e) => e?.stopPropagation()}
            okText='Yes'
            cancelText='No'
          >
            <a
              href='/#'
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              Remove
            </a>
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Layout className={styles.root}>
      <Layout.Header style={rootStyles.header}>
        <PageHeader onBack={() => history.goBack()} title='Postmark Settings List' extra={[<CreatePostmarkSetting key='1' />]} />
      </Layout.Header>
      <Layout.Content style={rootStyles.contentBreadcrumbs}>
        <Breadcrumbs
          items={[
            { title: 'Main', url: '/' },
            { title: 'Settings', url: '/' },
            { title: 'Plugins', url: '' },
            { title: 'Postmark Settings', url: '/settings/plugins' }
          ]}
        />
      </Layout.Content>
      <Layout.Content className={styles.contentComponent}>
        <Table
          columns={columns}
          dataSource={postmarkSettingsList}
          bordered
          rowKey={(record) => record.id}
          loading={isLoading}
          pagination={{
            onChange: changeCurrentPage,
            current: currentPage,
            total
          }}
        />
      </Layout.Content>
    </Layout>
  )
}

export default connector(PostmarkSettingsList)
